import { InstallationData, isRefrigerant } from "@/installation/installation";
import { HealthStatus } from "@/installation/garyStatus";
import { SublocationData } from "@/sublocation/sublocation";

export type ContactInfo = {
  name?: string;
  phone?: string;
  email?: string;
  position?: string;
}

export type LocationData = {
  id: number;
  name: string;
  address_line_1: string;
  address_line_2?: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  latitude: number;
  longitude: number;
  coi: any;
  coi_expiration: any;
  square_feet: any;
  site_status: string;
  organization: number;
  contact_info: ContactInfo[];
  installation_set: InstallationData[];
  sublocations: SublocationData[];
  access_notes?: string;
  image?: string;
  health_status: HealthStatus;
  is_snoozed: boolean;
  is_active: boolean;
}

export const allRefrigerantAssetsAtLocation = (location: LocationData) => location.installation_set.filter(isRefrigerant);
